module.exports = require("babel-runtime/core-js/object/define-property");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/define-property"
// module id = 30
// module chunks = 0